<template>
  <details-purchases/>
</template>

<script>
import detailsPurchases from '../../../components/user-profile/details-purchases'
export default {
  name: 'DetailsPurchasesView',
  components: {
    detailsPurchases
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/user-profile/details-purchases.view.vue